export default __webpack_public_path__ + "static/media/google-play-white.96215768.svg";